/** Where people reach us. */
export const CONTACT_EMAIL = 'hello@floto.ai';

/**
 * The sample report: a real first-pass run against the University of
 * Washington's deliberately inaccessible Accessible University demo page.
 * null would make the page offer to email one instead.
 */
export const SAMPLE_REPORT_URL: string | null = '/sample-report.pdf';

/** Where we are. Shown in About and the footer. */
export const OFFICES = {
  headquarters: 'US',
  operations: ['the UK', 'India'],
};

/** Registered office (Delaware), one line per postal-address line. */
export const REGISTERED_ADDRESS: string[] = [
  'Floto, Inc.',
  '251 Little Falls Drive',
  'Wilmington, DE 19808',
];
